import { ref } from 'vue';
import type { User } from '@/entities/User';
import type { ApiResponse } from '@/shared/lib';
import { userApi } from '@/entities/User';

export function useFetchUsers() {
  const users = ref<ApiResponse<User[]>>({ success: false, data: [] });

  const fetchAllUsers = async () => {
    try {
      const response = await userApi.getAllUsers();
      users.value = response;
    } catch (error) {
      console.error('Error fetching users:', error);
      users.value = { success: false, message: 'Failed to fetch users' };
    }
  };

  return {
    users,
    fetchAllUsers,
  };
}
